import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";

import Divider from "@material-ui/core/Divider";
import {getTranslation} from "../../helpers/get-translation";

const styles = theme => ({
	image: {
		height: "40px",
		width: "40px",
	},
	circleAvatar: {
		borderRadius: "50px",
	},
	arrow: {
		height: '20px',
		'margin-right':'15px',
	},
	button: {
		'&:focus':{
			background: 'none'
		}
	},
	text: {
		padding: "0 16px",
		"& > span":{
			textOverflow: "ellipsis",
			width: "100%",
			//white-space: "nowrap",
			overflow: "hidden",
		}
	}
});

function SettingsOptionButton(props) {
	const { name, img, classes, isLast, onClick, hasCircleImage, placeholder } = props;

	const imageClass = [classes.image];
	if(hasCircleImage){
		imageClass.push(classes.circleAvatar)
	}

	return (
		<div>
			<ListItem button={true} onClick={onClick} className={classes.button}>
				{ placeholder &&
					<img className={imageClass.join(" ")} src={img} onError={(e) => {e.target.onerror = null; e.target.src=placeholder}} />
				}
				{ !placeholder &&
					<img className={imageClass.join(" ")} src={img} />
				}
				<ListItemText primary={name} className={classes.text}/>
				<img className={classes.arrow} src={getTranslation("image_settings_arrow_button")} alt="Next arrow"/>
			</ListItem>
			{isLast || <Divider variant="inset" />}
		</div>
	);
}

SettingsOptionButton.propTypes = {
	name: PropTypes.string.isRequired,
	img: PropTypes.string.isRequired,
	placeholder: PropTypes.string,
	isLast: PropTypes.bool,
	hasCircleImage: PropTypes.bool,

	classes: PropTypes.shape({
		image: PropTypes.string.isRequired,
		arrow: PropTypes.string.isRequired,
	}).isRequired,

	onClick: PropTypes.func
};

export default withStyles(styles)(SettingsOptionButton);
